/**
 * Panel — surface card with optional title and subtitle.
 *
 * `fill` opts the panel into passing its own height down to its body. A panel is usually as
 * tall as what is in it, but a panel that is a stretched grid item is as tall as its ROW, and
 * the extra height stops at this component unless the body is told to take it. Without it a
 * card that has been stretched can only sit in its box, which is what left the Credit card
 * with its content in the top half and open paper underneath. Opt-in rather than default: a
 * body that grows changes nothing for a panel sized by its content, but it would change what
 * `justify`/`items` mean for any caller that already lays its children out.
 */
export default function Panel({
  title,
  sub,
  children,
  span = 1,
  noPad,
  fill,
  sx,
}) {
  return (
    <div
      className={`bg-surface border border-line rounded-none overflow-hidden${fill ? " h-full flex flex-col" : ""}`}
      style={{ gridColumn: `span ${span}`, ...sx }}
    >
      {title && (
        <div className="px-4 pt-3 pb-2 border-b border-line flex items-baseline gap-2">
          <span className="text-xs font-semibold text-fg2 uppercase tracking-wider">
            {title}
          </span>
          {sub && <span className="text-xs text-fg3">{sub}</span>}
        </div>
      )}
      <div
        className={`${noPad ? "" : "px-4 py-3"}${fill ? " flex-1 min-h-0" : ""}`}
      >
        {children}
      </div>
    </div>
  );
}
